<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">编辑</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="add-clue">
            <div class="left-menu">
                <a href="javascript:;">
                    <span>基础信息</span>
                    <a-icon type="right" />
                </a>
            </div>
            <div class="right-content">
                <div class="top-title">
                    基础信息
                </div>
                <div class="add-content">
                    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-input v-model="labelitem['id']" hidden></a-input>
                        <a-form-item v-for="(item,i) in system_field_list" :key="i" :label="item.name"> 
                            
                            <a-input v-model="labelitem[item.field_name]" v-if="item.type=='text'||item.type=='mobile'||item.type=='email'" placeholder="请输入"/>
                            <a-select v-model="labelitem[item.field_name]" v-if="item.type=='radio'" placeholder="请选择" style="width: 100%">
                                <a-select-option :value="option" v-for="(option,idx) in item.option_arr" :key="idx">
                                    {{option}}
                                </a-select-option>
                            </a-select>
                            <a-date-picker v-model="labelitem[item.field_name]"  v-if="item.type=='date'"/>
                            <a-textarea v-model="labelitem[item.field_name]" v-if="item.type=='textarea'" placeholder="请输入" :auto-size="{ minRows: 2,maxRows:6}"/>
                        </a-form-item>
     
                    </a-form>
                </div>
               
            </div>
        </div>

        <div class="add-button">
            <a-button icon="close-circle" theme="filled" @click="quit">取消</a-button>
            <a-button @click="editclue" type="primary" icon="check-circle" theme="filled">保存</a-button>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            fieldlist:"",
            system_field_list:"",
            addresoptions:[],
            labelitem:{},
            labelname:{}
        }
    },
 mounted(){
        // 字段
        this.$axios.get('/api/datafieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
                for(var j in data2){
                    this.labelname[data2[j].field_name]=""
                }
                // alert(JSON.stringify(this.labelitem))
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

        this.$axios.get('/api/getdatadetail',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:this.$route.query.id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.labelitem=res.data.data.info
                this.labelitem.id=this.$route.query.id
            }
        })

    },
    methods:{
        // 取消
        quit(){
            this.$router.go(-1);
        },
        // 编辑
        editclue(){
            this.$axios.post('/api/editdata',this.labelitem,{
                headers: {
                    "appid": this.appSet.appid, 
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var id=this.$route.query.id
                    this.$router.push({path: '/cluedetail',query:{ id:id}});
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleChange(){

        },
        date(){

        },
        onPanelChange(value, mode) {

        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/customer/edit.vue